import React from "react";
import { useLang } from "@/context/LanguageContext";
import { PawIcon, InstagramIcon } from "@/components/Icons";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer
      className="relative overflow-hidden text-white"
      style={{ background: "linear-gradient(135deg, #5a3221 0%, #3a1f12 100%)" }}
      data-testid="site-footer"
    >
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-14 grid md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#f7c5c0] to-[#f4956a] flex items-center justify-center shadow-md">
              <PawIcon size={24} className="text-white" />
            </div>
            <div>
              <p className="font-display text-xl text-white">Carol Tierbetreuung</p>
              <p className="text-xs tracking-[0.2em] uppercase text-white/80">Embrach · Zürich</p>
            </div>
          </div>
          <p className="text-white/85 mt-4 text-sm leading-relaxed max-w-sm">{t.footer.tagline}</p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-display text-base mb-3 text-[#fbe1de] tracking-wide">{t.footer.quick}</h4>
          <ul className="space-y-2 text-sm text-white/90">
            <li><a href="#home" className="hover:text-[#f7c5c0] transition-colors">{t.nav.home}</a></li>
            <li><a href="#services" className="hover:text-[#f7c5c0] transition-colors">{t.nav.services}</a></li>
            <li><a href="#about" className="hover:text-[#f7c5c0] transition-colors">{t.nav.about}</a></li>
            <li><a href="#contact" className="hover:text-[#f7c5c0] transition-colors">{t.nav.contact}</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-display text-base mb-3 text-[#fbe1de] tracking-wide">{t.footer.legal}</h4>
          <ul className="space-y-2 text-sm text-white/90">
            <li><a href="#" className="hover:text-[#f7c5c0] transition-colors">{t.footer.agb}</a></li>
            <li><a href="#" className="hover:text-[#f7c5c0] transition-colors">{t.footer.privacy}</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-display text-base mb-3 text-[#fbe1de] tracking-wide">{t.footer.social}</h4>
          <div className="flex gap-3">
            <a
              href="https://www.instagram.com/carol.tierbetreuung"
              target="_blank"
              rel="noreferrer"
              className="w-11 h-11 rounded-full bg-white/15 hover:bg-[#f4956a] transition-colors flex items-center justify-center text-white"
              data-testid="footer-instagram"
              aria-label="Instagram"
            >
              <InstagramIcon size={20} />
            </a>
          </div>
        </div>
      </div>

      <div className="relative border-t border-white/15">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 text-center text-xs text-white/85">
          {t.footer.rights}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
